<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="layers-outline"></ion-icon> Physical Infrastructure</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Availability of adequate space, facilities, infrastructure and
              common shared facilities that are essential for running Startups
              from the Incubation Center premises. This includes availability of
              specialized machineries, computational facilities, laboratories,
              etc., specific to the thrust areas of the Incubator.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Incubation Space; Conference / Meeting Room; Laboratory Space;
              Computers; Utilities
            </li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Dedicated area for Incubation Center
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.dedicatedAreaStatus)"
                    [style.background]="pickColor(getValue.dedicatedAreaStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.dedicatedAreaStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Dedicated area for Incubation Center</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.dedicatedAreaStatus != 2 &&
                        getValue.dedicatedAreaStatus != 4 &&
                        getValue.dedicatedAreaStatus != 5 &&
                        getValue.dedicatedAreaStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="dedicatedAreaIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsonechecked"
                          (change)="
                            showOptionsone(
                              $event.value,
                              '.upload0',
                              0,
                              '.set-succ0'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.dedicatedAreaIncCentre.touched &&
                              setting.dedicatedAreaIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.dedicatedAreaIncCentre.touched &&
                            setting.dedicatedAreaIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.dedicatedAreaIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsonechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Area allotted for Incubation Centre (in Sq. ft)
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Area allotted for Incubation Centre (in Sq. ft) "
                                (change)="
                                  setStatus($event, 'dedicatedAreaStatus', 7)
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="dedicatedAreaSqftArea"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.dedicatedAreaSqftArea.touched &&
                                    setting.dedicatedAreaSqftArea.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.dedicatedAreaSqftArea.touched &&
                                  setting.dedicatedAreaSqftArea.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.dedicatedAreaSqftArea.errors
                                      .required
                                  "
                                  >Area allotted for Incubation Centre (in Sq.
                                  ft) is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload0">
                                  <input
                                    type="file"
                                    formControlName="dedicatedAreaImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.dedicatedAreaImagefile
                                          .touched &&
                                        setting.dedicatedAreaImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload0',
                                        0,
                                        '.set-succ0'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.dedicatedAreaImagefile.touched &&
                                    setting.dedicatedAreaImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.dedicatedAreaImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload0"
                                  (click)="
                                    removeFile('.upload0', 0, '.set-succ0')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.dedicatedAreaStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.dedicatedAreaReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.dedicatedAreaStatus == 2 ||
                        getValue.dedicatedAreaStatus == 4 ||
                        getValue.dedicatedAreaStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.dedicatedAreaIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Area allotted for Incubation Centre (in Sq. ft) :
                            <b>{{ getValue.dedicatedAreaSqftArea }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.dedicatedAreaDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.dedicatedAreaStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.dedicatedAreaReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Office space and Co-working space with Computer, Air
                    Conditioner and other mandatory equipments
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.officeAndCoWorkingSpaceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.officeAndCoWorkingSpaceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.officeAndCoWorkingSpaceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Office space and Co-working space with Computer, Air
                      Conditioner and other mandatory equipments
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.officeAndCoWorkingSpaceStatus != 2 &&
                        getValue.officeAndCoWorkingSpaceStatus != 4 &&
                        getValue.officeAndCoWorkingSpaceStatus != 5 &&
                        getValue.officeAndCoWorkingSpaceStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="officeAndCoWorkingSpaceIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionstwochecked"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.officeAndCoWorkingSpaceIncCentre
                                .touched &&
                              setting.officeAndCoWorkingSpaceIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.officeAndCoWorkingSpaceIncCentre.touched &&
                            setting.officeAndCoWorkingSpaceIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.officeAndCoWorkingSpaceIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionstwochecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="officeAndCoWorkingSpaceImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.officeAndCoWorkingSpaceImagefile
                                          .touched &&
                                        setting.officeAndCoWorkingSpaceImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.officeAndCoWorkingSpaceImagefile
                                      .touched &&
                                    setting.officeAndCoWorkingSpaceImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.officeAndCoWorkingSpaceImagefile
                                        .errors.required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.officeAndCoWorkingSpaceStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.officeAndCoWorkingSpaceReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.officeAndCoWorkingSpaceStatus == 2 ||
                        getValue.officeAndCoWorkingSpaceStatus == 4 ||
                        getValue.officeAndCoWorkingSpaceStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.officeAndCoWorkingSpaceIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.officeAndCoWorkingSpaceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.officeAndCoWorkingSpaceStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.officeAndCoWorkingSpaceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Maker space / Prototype development centre / Analytical labs
                    / Machineries / Fields established as per the thrust areas
                    supported
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.makerSpacePrototypeStatus)
                    "
                    [style.background]="
                      pickColor(getValue.makerSpacePrototypeStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.makerSpacePrototypeStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Maker space / Prototype development centre / Analytical
                      labs / Machineries / Fields established as per the thrust
                      areas supported
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.makerSpacePrototypeStatus != 2 &&
                        getValue.makerSpacePrototypeStatus != 4 &&
                        getValue.makerSpacePrototypeStatus != 5 &&
                        getValue.makerSpacePrototypeStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="makerSpacePrototypeIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsthreechecked"
                          (change)="
                            showOptionsthree(
                              $event.value,
                              '.upload2',
                              2,
                              '.set-succ2'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.makerSpacePrototypeIncCentre.touched &&
                              setting.makerSpacePrototypeIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.makerSpacePrototypeIncCentre.touched &&
                            setting.makerSpacePrototypeIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.makerSpacePrototypeIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsthreechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >URL from Incubation Center Website
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter URL from Incubation Center Website"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'makerSpacePrototypeStatus',
                                        7
                                      )
                                    "
                                    formControlName="makerSpacePrototypeUrlIcWebsite"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.makerSpacePrototypeUrlIcWebsite
                                          .touched &&
                                        setting.makerSpacePrototypeUrlIcWebsite
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.makerSpacePrototypeUrlIcWebsite
                                        .touched &&
                                      setting.makerSpacePrototypeUrlIcWebsite
                                        .errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.makerSpacePrototypeUrlIcWebsite
                                          .errors.required
                                      "
                                      >URL from Incubation Center Website is
                                      required</span
                                    >
                                    <span
                                      *ngIf="
                                        setting.makerSpacePrototypeUrlIcWebsite
                                          .errors.url
                                      "
                                      >Please enter proper url format</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of support infrastructure established
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter No. of support infrastructure established"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'makerSpacePrototypeStatus',
                                        7
                                      )
                                    "
                                    formControlName="makerSpacePrototypeUtilitySpace"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.makerSpacePrototypeUtilitySpace
                                          .touched &&
                                        setting.makerSpacePrototypeUtilitySpace
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.makerSpacePrototypeUtilitySpace
                                        .touched &&
                                      setting.makerSpacePrototypeUtilitySpace
                                        .errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.makerSpacePrototypeUtilitySpace
                                          .errors.required
                                      "
                                      >No. of support infrastructure established
                                      is required</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload2">
                                  <input
                                    type="file"
                                    formControlName="makerSpacePrototypeImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.makerSpacePrototypeImagefile
                                          .touched &&
                                        setting.makerSpacePrototypeImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload2',
                                        2,
                                        '.set-succ2'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.makerSpacePrototypeImagefile
                                      .touched &&
                                    setting.makerSpacePrototypeImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.makerSpacePrototypeImagefile
                                        .errors.required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload2"
                                  (click)="
                                    removeFile('.upload2', 2, '.set-succ2')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.makerSpacePrototypeStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.makerSpacePrototypeReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.makerSpacePrototypeStatus == 2 ||
                        getValue.makerSpacePrototypeStatus == 4 ||
                        getValue.makerSpacePrototypeStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.makerSpacePrototypeIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.makerSpacePrototypeUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.makerSpacePrototypeUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of support infrastructure established :
                            <b>{{
                              getValue.makerSpacePrototypeUtilitySpace
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.makerSpacePrototypeDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.makerSpacePrototypeStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.makerSpacePrototypeReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Specialized software, tools and inventories for designing
                    and IoT based projects
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.specializedSoftwareStatus)
                    "
                    [style.background]="
                      pickColor(getValue.specializedSoftwareStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.specializedSoftwareStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Specialized software, tools and inventories for designing
                      and IoT based projects
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.specializedSoftwareStatus != 2 &&
                        getValue.specializedSoftwareStatus != 4 &&
                        getValue.specializedSoftwareStatus != 5 &&
                        getValue.specializedSoftwareStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="specializedSoftwareIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfourchecked"
                          (change)="
                            showOptionsfour(
                              $event.value,
                              '.upload3',
                              3,
                              '.set-succ3'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.specializedSoftwareIncCentre.touched &&
                              setting.specializedSoftwareIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.specializedSoftwareIncCentre.touched &&
                            setting.specializedSoftwareIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.specializedSoftwareIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsfourchecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload3">
                                  <input
                                    type="file"
                                    formControlName="specializedSoftwareImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.specializedSoftwareImagefile
                                          .touched &&
                                        setting.specializedSoftwareImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload3',
                                        3,
                                        '.set-succ3'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.specializedSoftwareImagefile
                                      .touched &&
                                    setting.specializedSoftwareImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.specializedSoftwareImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload3"
                                  (click)="
                                    removeFile('.upload3', 3, '.set-succ3')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.specializedSoftwareStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.specializedSoftwareReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.specializedSoftwareStatus == 2 ||
                        getValue.specializedSoftwareStatus == 4 ||
                        getValue.specializedSoftwareStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.specializedSoftwareIncCentre }}</b>
                          </p>
                        </div>
                        <!-- <div class="sub-div">
                                                    <p class="p-lbl">No. of such facilities created :
                                                        <b>{{getValue.specializedSoftwareNoOfFacility}}</b>
                                                    </p>
                                                </div> -->
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.specializedSoftwareDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.specializedSoftwareStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.specializedSoftwareReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    MVPs and Projects developed within the Incubation Center
                    facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.mvpsAndProjectsStatus)"
                    [style.background]="
                      pickColor(getValue.mvpsAndProjectsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.mvpsAndProjectsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      MVPs and Projects developed within the Incubation Center
                      facility
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.mvpsAndProjectsStatus != 2 &&
                        getValue.mvpsAndProjectsStatus != 4 &&
                        getValue.mvpsAndProjectsStatus != 5 &&
                        getValue.mvpsAndProjectsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="mvpsAndProjectsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfivechecked"
                          (change)="
                            showOptionsfive(
                              $event.value,
                              '.upload4',
                              4,
                              '.set-succ4'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.mvpsAndProjectsIncCentre.touched &&
                              setting.mvpsAndProjectsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.mvpsAndProjectsIncCentre.touched &&
                            setting.mvpsAndProjectsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.mvpsAndProjectsIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsfivechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >URL from Incubation Center Website
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter URL from Incubation Center Website"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'mvpsAndProjectsStatus',
                                        7
                                      )
                                    "
                                    formControlName="mvpsAndProjectsUrlIcWebsite"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.mvpsAndProjectsUrlIcWebsite
                                          .touched &&
                                        setting.mvpsAndProjectsUrlIcWebsite
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.mvpsAndProjectsUrlIcWebsite
                                        .touched &&
                                      setting.mvpsAndProjectsUrlIcWebsite.errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.mvpsAndProjectsUrlIcWebsite
                                          .errors.required
                                      "
                                      >URL from Incubation Center Website is
                                      required</span
                                    >
                                    <span
                                      *ngIf="
                                        setting.mvpsAndProjectsUrlIcWebsite
                                          .errors.url
                                      "
                                      >Please enter proper url format</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of MVPs & Prototypes developed
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter No. of MVPs & Prototypes developed"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'mvpsAndProjectsStatus',
                                        7
                                      )
                                    "
                                    formControlName="mvpsAndProjectsUrlNoOfMVP"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.mvpsAndProjectsUrlNoOfMVP
                                          .touched &&
                                        setting.mvpsAndProjectsUrlNoOfMVP.errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.mvpsAndProjectsUrlNoOfMVP
                                        .touched &&
                                      setting.mvpsAndProjectsUrlNoOfMVP.errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.mvpsAndProjectsUrlNoOfMVP.errors
                                          .required
                                      "
                                      >No. of MVPs & Prototypes developed is
                                      required</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload4">
                                  <input
                                    type="file"
                                    formControlName="mvpsAndProjectsImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.mvpsAndProjectsImagefile
                                          .touched &&
                                        setting.mvpsAndProjectsImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload4',
                                        4,
                                        '.set-succ4'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.mvpsAndProjectsImagefile.touched &&
                                    setting.mvpsAndProjectsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.mvpsAndProjectsImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload4"
                                  (click)="
                                    removeFile('.upload4', 4, '.set-succ4')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.mvpsAndProjectsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.mvpsAndProjectsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.mvpsAndProjectsStatus == 2 ||
                        getValue.mvpsAndProjectsStatus == 4 ||
                        getValue.mvpsAndProjectsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.mvpsAndProjectsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.mvpsAndProjectsUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.mvpsAndProjectsUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of MVPs & Prototypes developed :
                            <b>{{ getValue.mvpsAndProjectsUrlNoOfMVP }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.mvpsAndProjectsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.mvpsAndProjectsStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.mvpsAndProjectsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Separate meeting / conference / training halls
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.separateMeetingStatus)"
                    [style.background]="
                      pickColor(getValue.separateMeetingStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.separateMeetingStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Separate meeting / conference / training halls</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.separateMeetingStatus != 2 &&
                        getValue.separateMeetingStatus != 4 &&
                        getValue.separateMeetingStatus != 5 &&
                        getValue.separateMeetingStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="separateMeetingIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionssixchecked"
                          (change)="
                            showOptionssix(
                              $event.value,
                              '.upload5',
                              5,
                              '.set-succ5'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.separateMeetingIncCentre.touched &&
                              setting.separateMeetingIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.separateMeetingIncCentre.touched &&
                            setting.separateMeetingIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.separateMeetingIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionssixchecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >URL from Incubation Center Website
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter URL from Incubation Center Website"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'separateMeetingStatus',
                                        7
                                      )
                                    "
                                    formControlName="separateMeetingUrlIcWebsite"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.separateMeetingUrlIcWebsite
                                          .touched &&
                                        setting.separateMeetingUrlIcWebsite
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.separateMeetingUrlIcWebsite
                                        .touched &&
                                      setting.separateMeetingUrlIcWebsite.errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.separateMeetingUrlIcWebsite
                                          .errors.required
                                      "
                                      >URL from Incubation Center Website is
                                      required</span
                                    >
                                    <span
                                      *ngIf="
                                        setting.separateMeetingUrlIcWebsite
                                          .errors.url
                                      "
                                      >Please enter proper url format</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of such facilities created
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter No. of such facilities created"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'separateMeetingStatus',
                                        7
                                      )
                                    "
                                    formControlName="separateMeetingUrlNoOfFacility"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.separateMeetingUrlNoOfFacility
                                          .touched &&
                                        setting.separateMeetingUrlNoOfFacility
                                          .errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.separateMeetingUrlNoOfFacility
                                        .touched &&
                                      setting.separateMeetingUrlNoOfFacility
                                        .errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.separateMeetingUrlNoOfFacility
                                          .errors.required
                                      "
                                      >No. of such facilities created is
                                      required</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload5">
                                  <input
                                    type="file"
                                    formControlName="separateMeetingImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.separateMeetingImagefile
                                          .touched &&
                                        setting.separateMeetingImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload5',
                                        5,
                                        '.set-succ5'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.separateMeetingImagefile.touched &&
                                    setting.separateMeetingImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.separateMeetingImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload5"
                                  (click)="
                                    removeFile('.upload5', 5, '.set-succ5')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.separateMeetingStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.separateMeetingReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.separateMeetingStatus == 2 ||
                        getValue.separateMeetingStatus == 4 ||
                        getValue.separateMeetingStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.separateMeetingIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.separateMeetingUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.separateMeetingUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of such facilities created :
                            <b>{{ getValue.separateMeetingUrlNoOfFacility }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.separateMeetingDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.separateMeetingStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.separateMeetingReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Facility (Incubation Centre) timings
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.facilityTimingsStatus)"
                    [style.background]="
                      pickColor(getValue.facilityTimingsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.facilityTimingsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Facility (Incubation Centre) timings</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.facilityTimingsStatus != 2 &&
                        getValue.facilityTimingsStatus != 4 &&
                        getValue.facilityTimingsStatus != 5 &&
                        getValue.facilityTimingsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="facilityTimingsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionssevenchecked"
                          (change)="
                            showOptionsseven(
                              $event.value,
                              '.upload6',
                              6,
                              '.set-succ6'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.facilityTimingsIncCentre.touched &&
                              setting.facilityTimingsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.facilityTimingsIncCentre.touched &&
                            setting.facilityTimingsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.facilityTimingsIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionssevenchecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                (change)="
                                  setStatus($event, 'facilityTimingsStatus', 7)
                                "
                                formControlName="facilityTimingsUrlIcWebsite"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.facilityTimingsUrlIcWebsite
                                      .touched &&
                                    setting.facilityTimingsUrlIcWebsite.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.facilityTimingsUrlIcWebsite.touched &&
                                  setting.facilityTimingsUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.facilityTimingsUrlIcWebsite.errors
                                      .required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.facilityTimingsUrlIcWebsite.errors
                                      .url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <mat-label class="pb-5"
                              >Facility Timings
                              <span class="text-danger">*</span></mat-label
                            >
                            <br />
                            <div class="mt-3">
                              <mat-radio-group
                                formControlName="facilityTimings"
                                (change)="
                                  setStatus($event, 'facilityTimingsStatus', 7)
                                "
                                class="example-margin"
                                aria-label="Select an option"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.facilityTimings.touched &&
                                    setting.facilityTimings.errors
                                }"
                              >
                                <mat-radio-button value="16X7"
                                  >16X7</mat-radio-button
                                >
                                <mat-radio-button value="24X7"
                                  >24X7</mat-radio-button
                                >
                                <!-- <mat-radio-button value="Other">Other</mat-radio-button> -->
                              </mat-radio-group>
                              <br />
                              <mat-error
                                *ngIf="
                                  setting.facilityTimings.touched &&
                                  setting.facilityTimings.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.facilityTimings.errors.required
                                  "
                                  >Facility Timings is required</span
                                >
                              </mat-error>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload6">
                                  <input
                                    type="file"
                                    formControlName="facilityTimingsImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.facilityTimingsImagefile
                                          .touched &&
                                        setting.facilityTimingsImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload6',
                                        6,
                                        '.set-succ6'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.facilityTimingsImagefile.touched &&
                                    setting.facilityTimingsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.facilityTimingsImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload6"
                                  (click)="
                                    removeFile('.upload6', 6, '.set-succ6')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.facilityTimingsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.facilityTimingsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.facilityTimingsStatus == 2 ||
                        getValue.facilityTimingsStatus == 4 ||
                        getValue.facilityTimingsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.facilityTimingsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.facilityTimingsUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.facilityTimingsUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Facility Timings :
                            <b>{{ getValue.facilityTimings }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.facilityTimingsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.facilityTimingsStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.facilityTimingsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Trainings conducted using the Incubation Center facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.trainingsConductedStatus)"
                    [style.background]="
                      pickColor(getValue.trainingsConductedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.trainingsConductedStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Trainings conducted using the Incubation Center facility
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.trainingsConductedStatus != 2 &&
                        getValue.trainingsConductedStatus != 4 &&
                        getValue.trainingsConductedStatus != 5 &&
                        getValue.trainingsConductedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="trainingsConductedIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options8checked"
                          (change)="
                            showOptions8(
                              $event.value,
                              '.upload7',
                              7,
                              '.set-succ7'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.trainingsConductedIncCentre.touched &&
                              setting.trainingsConductedIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.trainingsConductedIncCentre.touched &&
                            setting.trainingsConductedIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.trainingsConductedIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options8checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Programs conducted
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Programs conducted"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'trainingsConductedStatus',
                                    7
                                  )
                                "
                                formControlName="trainingsConductedCount"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.trainingsConductedCount.touched &&
                                    setting.trainingsConductedCount.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.trainingsConductedCount.touched &&
                                  setting.trainingsConductedCount.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.trainingsConductedCount.errors
                                      .required
                                  "
                                  >No. of Programs conducted is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload7">
                                  <input
                                    type="file"
                                    formControlName="trainingsConductedImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.trainingsConductedImagefile
                                          .touched &&
                                        setting.trainingsConductedImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload7',
                                        7,
                                        '.set-succ7'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.trainingsConductedImagefile
                                      .touched &&
                                    setting.trainingsConductedImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.trainingsConductedImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload7"
                                  (click)="
                                    removeFile('.upload7', 7, '.set-succ7')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.trainingsConductedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.trainingsConductedReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.trainingsConductedStatus == 2 ||
                        getValue.trainingsConductedStatus == 4 ||
                        getValue.trainingsConductedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.trainingsConductedIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs conducted :
                            <b>{{ getValue.trainingsConductedCount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.trainingsConductedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.trainingsConductedStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.trainingsConductedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Startups utilizing office space and other facilities
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.startupsUtilizingOffSpaceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.startupsUtilizingOffSpaceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.startupsUtilizingOffSpaceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Startups utilizing office space and other facilities
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.startupsUtilizingOffSpaceStatus != 2 &&
                        getValue.startupsUtilizingOffSpaceStatus != 4 &&
                        getValue.startupsUtilizingOffSpaceStatus != 5 &&
                        getValue.startupsUtilizingOffSpaceStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="startupsUtilizingOffSpaceCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options11checked"
                          (change)="
                            showOptions11(
                              $event.value,
                              '.upload10',
                              10,
                              '.set-succ10'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.startupsUtilizingOffSpaceCentre.touched &&
                              setting.startupsUtilizingOffSpaceCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.startupsUtilizingOffSpaceCentre.touched &&
                            setting.startupsUtilizingOffSpaceCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.startupsUtilizingOffSpaceCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options11checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                ><span class="text-danger">*</span> Total
                                percentatge of Startups utilizing the Office and
                                space and other facilities created</mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Total percentatge of Startups"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'startupsUtilizingOffSpaceStatus',
                                    7
                                  )
                                "
                                formControlName="startupsUtilizingOffSpaceTotalPercent"
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .startupsUtilizingOffSpaceTotalPercent
                                      .touched &&
                                    setting
                                      .startupsUtilizingOffSpaceTotalPercent
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.startupsUtilizingOffSpaceTotalPercent
                                    .touched &&
                                  setting.startupsUtilizingOffSpaceTotalPercent
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .startupsUtilizingOffSpaceTotalPercent
                                      .errors.required
                                  "
                                  >Total percentatge of Startups utilizing the
                                  Office and space and other facilities created
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload10">
                                  <input
                                    type="file"
                                    formControlName="startupsUtilizingOffSpaceImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .startupsUtilizingOffSpaceImagefile
                                          .touched &&
                                        setting
                                          .startupsUtilizingOffSpaceImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload10',
                                        10,
                                        '.set-succ10'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.startupsUtilizingOffSpaceImagefile
                                      .touched &&
                                    setting.startupsUtilizingOffSpaceImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.startupsUtilizingOffSpaceImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload10"
                                  (click)="
                                    removeFile('.upload10', 10, '.set-succ10')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.startupsUtilizingOffSpaceStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.startupsUtilizingOffSpaceReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.startupsUtilizingOffSpaceStatus == 2 ||
                        getValue.startupsUtilizingOffSpaceStatus == 4 ||
                        getValue.startupsUtilizingOffSpaceStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.startupsUtilizingOffSpaceCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Total percentatge of Startups utilizing the Office
                            and space and other facilities created :
                            <b>{{
                              getValue.startupsUtilizingOffSpaceTotalPercent
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.startupsUtilizingOffSpaceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.startupsUtilizingOffSpaceStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.startupsUtilizingOffSpaceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 010 -->
            <mat-expansion-panel [expanded]="step === 9" (opened)="setStep(9)">
              <mat-expansion-panel-header class="d-flex">
                <h6>10.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Policy for Co-creation or Co-incubation facility within the
                    Incubation Center and with external entitites
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.policyForCoCreationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.policyForCoCreationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.policyForCoCreationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Policy for Co-creation or Co-incubation facility within
                      the Incubation Center and with external entitites
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.policyForCoCreationStatus != 2 &&
                        getValue.policyForCoCreationStatus != 4 &&
                        getValue.policyForCoCreationStatus != 5 &&
                        getValue.policyForCoCreationStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="policyForCoCreationIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options9checked"
                          (change)="
                            showOptions9(
                              $event.value,
                              '.upload8',
                              8,
                              '.set-succ8'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.policyForCoCreationIncCentre.touched &&
                              setting.policyForCoCreationIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.policyForCoCreationIncCentre.touched &&
                            setting.policyForCoCreationIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.policyForCoCreationIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options9checked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload8">
                              <input
                                type="file"
                                formControlName="policyForCoCreationImagefile"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.policyForCoCreationImagefile
                                      .touched &&
                                    setting.policyForCoCreationImagefile.errors
                                }"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload8',
                                    8,
                                    '.set-succ8'
                                  )
                                "
                                id=""
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Uploading</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.policyForCoCreationImagefile.touched &&
                                setting.policyForCoCreationImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.policyForCoCreationImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload8"
                              (click)="removeFile('.upload8', 8, '.set-succ8')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.policyForCoCreationStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.policyForCoCreationReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.policyForCoCreationStatus == 2 ||
                        getValue.policyForCoCreationStatus == 4 ||
                        getValue.policyForCoCreationStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.policyForCoCreationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.policyForCoCreationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.policyForCoCreationStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.policyForCoCreationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[9])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 011 -->
            <mat-expansion-panel
              [expanded]="step === 10"
              (opened)="setStep(10)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>11.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Provision for other stakeholders who utilize the facility
                    (other than incubatees & Host Institution students) with
                    footfall
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.provisionForStakeholdersStatus)
                    "
                    [style.background]="
                      pickColor(getValue.provisionForStakeholdersStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.provisionForStakeholdersStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Provision for other stakeholders who utilize the facility
                      (other than incubatees & Host Institution students) with
                      footfall
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.provisionForStakeholdersStatus != 2 &&
                        getValue.provisionForStakeholdersStatus != 4 &&
                        getValue.provisionForStakeholdersStatus != 5 &&
                        getValue.provisionForStakeholdersStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="provisionForStakeholdersIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options10checked"
                          (change)="
                            showOptions10(
                              $event.value,
                              '.upload9',
                              9,
                              '.set-succ9'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.provisionForStakeholdersIncCentre
                                .touched &&
                              setting.provisionForStakeholdersIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.provisionForStakeholdersIncCentre.touched &&
                            setting.provisionForStakeholdersIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.provisionForStakeholdersIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options10checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of external Stakeholders
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of external Stakeholders"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'provisionForStakeholdersStatus',
                                    7
                                  )
                                "
                                formControlName="provisionForStakeholdersNoOfVisitor"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.provisionForStakeholdersNoOfVisitor
                                      .touched &&
                                    setting.provisionForStakeholdersNoOfVisitor
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.provisionForStakeholdersNoOfVisitor
                                    .touched &&
                                  setting.provisionForStakeholdersNoOfVisitor
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.provisionForStakeholdersNoOfVisitor
                                      .errors.required
                                  "
                                  >No. of external Stakeholders is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload9">
                                  <input
                                    type="file"
                                    formControlName="provisionForStakeholdersImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .provisionForStakeholdersImagefile
                                          .touched &&
                                        setting
                                          .provisionForStakeholdersImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload9',
                                        9,
                                        '.set-succ9'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.provisionForStakeholdersImagefile
                                      .touched &&
                                    setting.provisionForStakeholdersImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.provisionForStakeholdersImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload9"
                                  (click)="
                                    removeFile('.upload9', 9, '.set-succ9')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.provisionForStakeholdersStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.provisionForStakeholdersReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.provisionForStakeholdersStatus == 2 ||
                        getValue.provisionForStakeholdersStatus == 4 ||
                        getValue.provisionForStakeholdersStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.provisionForStakeholdersIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of external Stakeholders :
                            <b>{{
                              getValue.provisionForStakeholdersNoOfVisitor
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.provisionForStakeholdersDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.provisionForStakeholdersStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.provisionForStakeholdersReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[10])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 012 -->
            <mat-expansion-panel
              [expanded]="step === 11"
              (opened)="setStep(11)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>12.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Hackathons conducted in the Incubation Centre facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.hackathonsConductedStatus)
                    "
                    [style.background]="
                      pickColor(getValue.hackathonsConductedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.hackathonsConductedStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Hackathons conducted in the Incubation Centre facility
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.hackathonsConductedStatus != 2 &&
                        getValue.hackathonsConductedStatus != 4 &&
                        getValue.hackathonsConductedStatus != 5 &&
                        getValue.hackathonsConductedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="hackathonsConductedCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options12checked"
                          (change)="
                            showOptions12(
                              $event.value,
                              '.upload11',
                              11,
                              '.set-succ11'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.hackathonsConductedCentre.touched &&
                              setting.hackathonsConductedCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.hackathonsConductedCentre.touched &&
                            setting.hackathonsConductedCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.hackathonsConductedCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options12checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Programs conducted
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Programs conducted"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'hackathonsConductedStatus',
                                    7
                                  )
                                "
                                formControlName="hackathonsConductedNoOfHackathons"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.hackathonsConductedNoOfHackathons
                                      .touched &&
                                    setting.hackathonsConductedNoOfHackathons
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.hackathonsConductedNoOfHackathons
                                    .touched &&
                                  setting.hackathonsConductedNoOfHackathons
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.hackathonsConductedNoOfHackathons
                                      .errors.required
                                  "
                                  >Total Hacathons conducted is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload11">
                                  <input
                                    type="file"
                                    formControlName="hackathonsConductedImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.hackathonsConductedImagefile
                                          .touched &&
                                        setting.hackathonsConductedImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload11',
                                        11,
                                        '.set-succ11'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.hackathonsConductedImagefile
                                      .touched &&
                                    setting.hackathonsConductedImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.hackathonsConductedImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload11"
                                  (click)="
                                    removeFile('.upload11', 11, '.set-succ11')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.hackathonsConductedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.hackathonsConductedReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.hackathonsConductedStatus == 2 ||
                        getValue.hackathonsConductedStatus == 4 ||
                        getValue.hackathonsConductedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.hackathonsConductedCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs conducted :
                            <b>{{
                              getValue.hackathonsConductedNoOfHackathons
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.hackathonsConductedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.hackathonsConductedStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.hackathonsConductedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[11])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 013 -->
            <mat-expansion-panel
              [expanded]="step === 12"
              (opened)="setStep(12)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>13.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Revenue generated utilizing this facility
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.revenueGeneratedUsingSpaceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.revenueGeneratedUsingSpaceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.revenueGeneratedUsingSpaceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Revenue generated utilizing this facility</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.revenueGeneratedUsingSpaceStatus != 2 &&
                        getValue.revenueGeneratedUsingSpaceStatus != 4 &&
                        getValue.revenueGeneratedUsingSpaceStatus != 5 &&
                        getValue.revenueGeneratedUsingSpaceStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="revenueGeneratedUsingSpaceCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options13checked"
                          (change)="
                            showOptions13(
                              $event.value,
                              '.upload12',
                              12,
                              '.set-succ12'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.revenueGeneratedUsingSpaceCentre
                                .touched &&
                              setting.revenueGeneratedUsingSpaceCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.revenueGeneratedUsingSpaceCentre.touched &&
                            setting.revenueGeneratedUsingSpaceCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.revenueGeneratedUsingSpaceCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options13checked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload12">
                              <input
                                type="file"
                                formControlName="revenueGeneratedUsingSpaceImagefile"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.revenueGeneratedUsingSpaceImagefile
                                      .touched &&
                                    setting.revenueGeneratedUsingSpaceImagefile
                                      .errors
                                }"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload12',
                                    12,
                                    '.set-succ12'
                                  )
                                "
                                id=""
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Uploading</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.revenueGeneratedUsingSpaceImagefile
                                  .touched &&
                                setting.revenueGeneratedUsingSpaceImagefile
                                  .errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.revenueGeneratedUsingSpaceImagefile
                                    .errors.required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload12"
                              (click)="
                                removeFile('.upload12', 12, '.set-succ12')
                              "
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.revenueGeneratedUsingSpaceStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.revenueGeneratedUsingSpaceReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.revenueGeneratedUsingSpaceStatus == 2 ||
                        getValue.revenueGeneratedUsingSpaceStatus == 4 ||
                        getValue.revenueGeneratedUsingSpaceStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.revenueGeneratedUsingSpaceCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.revenueGeneratedUsingSpaceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.revenueGeneratedUsingSpaceStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.revenueGeneratedUsingSpaceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[12])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
